import { DEV_MOCK_DOCS_FLAG, DEV_MOCK_TEST_EDIT_KEY } from './constants';

declare const __ENVIRONMENT__: string;

const DEV_MOCK_ENVIRONMENTS = ['dev', 'fail', 'online', 'ninja'];

export function isDevMockEnvironment(): boolean {
    try {
        const env = String(__ENVIRONMENT__ || '').toLowerCase();

        return DEV_MOCK_ENVIRONMENTS.indexOf(env) >= 0;
    } catch {
        return false;
    }
}

export function resolveDevMockEditKey(data: { editKey?: string; EditKey?: string } | null | undefined): string {
    if (!data) {
        return '';
    }
    const raw = (data as any).editKey != null ? (data as any).editKey : (data as any).EditKey;
    return raw == null ? '' : String(raw).trim();
}

export function isDevMockTestEditKey(editKey: string | null | undefined): boolean {
    return !!editKey && String(editKey).trim() === DEV_MOCK_TEST_EDIT_KEY;
}

export function canOfferDevMockDocs(editKey: string | null | undefined): boolean {
    return DEV_MOCK_DOCS_FLAG && isDevMockEnvironment() && isDevMockTestEditKey(editKey);
}
